import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/notification-level/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const notificationLevel = {
  getAll: apiPathFunc(pathBase),
} as const;
